import { render, staticRenderFns } from "./LeaveCodeView.vue?vue&type=template&id=8c145bb0"
import script from "./LeaveCodeView.ts?vue&type=script&lang=ts&external"
export * from "./LeaveCodeView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports